import { render, staticRenderFns } from "./index.vue?vue&type=template&id=68fa304f&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=68fa304f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68fa304f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/vercel/workpath0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('68fa304f')) {
      api.createRecord('68fa304f', component.options)
    } else {
      api.reload('68fa304f', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=68fa304f&scoped=true&", function () {
      api.rerender('68fa304f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "srcPC/pages/trade/trust/index.vue"
export default component.exports